<template>
  <v-footer absolute app flat color="#444472">
    <v-container>
      <v-row class="align-center justify-space-around py-0">
        <v-col class="py-0" cols="auto">
          <!-- <router-link class="no-decoration white--text text-caption" to="privacy"> -->
          <a class="no-decoration white--text text-caption" target="_blank" href="https://www.jmooc.jp/privacy/">
            プライバシーポリシー
          </a>
          <!-- </router-link> -->
        </v-col>
        <v-col class="py-0" cols="auto">
          <router-link class="no-decoration white--text text-caption" target="_blank" to="/terms">
            利用規約
          </router-link>
        </v-col>
        <v-col class="py-0" cols="auto">
          <a class="no-decoration white--text text-caption" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScUkUvFa4bZawIqQwwG_PXDXBkz07drva3tSTzPOvspj4duww/viewform">
            お問い合わせ
          </a>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="center">
        <v-col class="white--text text-caption py-0" cols="12">
          © 2021 日本オープンオンライン教育推進協議会
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>

export default {
  name: 'AppFooter',
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
.no-decoration {
  text-decoration: none;
}
</style>
